module.exports = __webpack_public_path__ + "mn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mn.svg
// module id = 696
// module chunks = 0